<div class="row">
    <div class="col-md-3">


        <!--Card-->
        <div class="card card-cascade narrower">

            <!--Card image-->
            <div class="view overlay hm-white-slight waves-light" mdbWavesEffect>
                <img src="https://mdbootstrap.com/img/Photos/Horizontal/People/6-col/img%20%283%29.jpg" class="img-fluid">
                <a>
                    <div class="mask"></div>
                </a>
            </div>
            <!--/Card image-->

            <!--Card content-->
            <div class="card-body text-center">
                <!--Title-->
                <h4 class="card-title font-bold mb-2"><strong>Alice Mayer</strong></h4>
                <h5 class="indigo-text"><strong>Photographer</strong></h5>

                <h6 class='text-justify'><strong>About:</strong></h6>
                <p class='text-justify'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ratione perferendis quod animi dignissimos consectetur
                    quibusdam numquam laboriosam, minus, provident...</p>

                <div class="text-right">
                    <button type="button" class="btn btn-outline-primary btn-rounded  btn-sm" mdbWavesEffect>More...</button>
                </div>

            </div>
            <!--/.Card content-->

        </div>
        <!--/.Card-->

    </div>

    <div class="col-md-9">

        <!--Projects section v.2-->
        <section class="section text-center pb-3">

            <!--Section heading-->
            <!-- <h2 class="section-heading h1 pt-4"><strong>Latest projects:</strong></h2> -->
            <!--Section description-->

            <!--Grid row-->
            <div class="row d-flex justify-content-center">

                <!--Grid column-->
                <div class="col-lg-6 col-xl-5 mb-3">
                    
                                        <!--Card-->
                                        <div class="card card-cascade narrower d-flex mb-5">
                    
                                            <!--Card image-->
                                            <div class="view overlay hm-white-slight">
                                                <img src="https://mdbootstrap.com/img/Mockups/Horizontal/6-col/pro-profile-page.jpg" class="img-fluid" alt="">
                                                <a href="#">
                                                    <div class="mask"></div>
                                                </a>
                                            </div>
                    
                                            <!--Card content-->
                                            <div class="card-body">
                                                <!--Title-->
                                                <h4 class="card-title font-bold mb-3"><strong>Project name</strong></h4>
                                                <!--Text-->
                                                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.
                                                </p>
                                            </div>
                    
                                            <!--Card footer-->
                                            <div class="card-footer links-light">
                                                <span class="right"> 
                                                    <a href="" class="waves-effect p-2">Live Preview <i class="fa fa-photo ml-1"></i></a>
                                                </span>
                                            </div>
                    
                                        </div>
                                        <!--/.Card-->
                    
                                    </div>
                <!--Grid column-->

                <!--Grid column-->
                <div class="col-lg-6 col-xl-5 mb-3">

                    <!--Card-->
                    <div class="card card-cascade narrower d-flex mb-5">

                        <!--Card image-->
                        <div class="view overlay hm-white-slight">
                            <img src="https://mdbootstrap.com/img/Mockups/Horizontal/6-col/pro-signup.jpg" class="img-fluid" alt="">
                            <a href="#">
                                <div class="mask"></div>
                            </a>
                        </div>

                        <!--Card content-->
                        <div class="card-body">
                            <!--Title-->
                            <h4 class="card-title font-bold mb-3"><strong>Project name</strong></h4>
                            <!--Text-->
                            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>

                        <!--Card footer-->
                        <div class="card-footer links-light">
                            <span class="right"> 
                                <a href="" class="waves-effect p-2">Live Preview <i class="fa fa-photo ml-1"></i></a>
                            </span>
                        </div>

                    </div>
                    <!--/.Card-->

                </div>
                <!--Grid column-->

            </div>
            <!--Grid row-->

            <!--Grid row-->
            <div class="row d-flex justify-content-center">

                <!--Grid column-->
                <div class="col-lg-6 col-xl-5 mb-3">

                    <!--Card-->
                    <div class="card card-cascade narrower d-flex mb-5">

                        <!--Card image-->
                        <div class="view overlay hm-white-slight">
                            <img src="https://mdbootstrap.com/img/Mockups/Horizontal/6-col/pro-pricing.jpg" class="img-fluid" alt="">
                            <a href="#">
                                <div class="mask"></div>
                            </a>
                        </div>

                        <!--Card content-->
                        <div class="card-body">
                            <!--Title-->
                            <h4 class="card-title font-bold mb-3"><strong>Project name</strong></h4>
                            <!--Text-->
                            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                        </div>

                        <!--Card footer-->
                        <div class="card-footer links-light">
                            <span class="right"> 
                                <a href="" class="waves-effect p-2">Live Preview <i class="fa fa-photo ml-1"></i></a>
                            </span>
                        </div>

                    </div>
                    <!--/.Card-->

                </div>
                <!--Grid column-->

                <!--Grid column-->
                <div class="col-lg-6 col-xl-5 mb-3">

                    <!--Card-->
                    <div class="card card-cascade narrower d-flex mb-5">

                        <!--Card image-->
                        <div class="view overlay hm-white-slight">
                            <img src="https://mdbootstrap.com/img/Mockups/Horizontal/6-col/pro-landing.jpg" class="img-fluid" alt="">
                            <a href="#">
                                <div class="mask"></div>
                            </a>
                        </div>

                        <!--Card content-->
                        <div class="card-body">
                            <!--Title-->
                            <h4 class="card-title font-bold mb-3"><strong>Project name</strong></h4>
                            <!--Text-->
                            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.
                            </p>
                           
                        </div>

                        <!--Card footer-->
                        <div class="card-footer links-light">
                            <span class="right"> 
                                <a href="" class="waves-effect p-2">Live Preview <i class="fa fa-photo ml-1"></i></a>
                            </span>
                        </div>

                    </div>
                    <!--/.Card-->

                </div>
                <!--Grid column-->
                <div class="col-lg-12">
                    <div class="text-center">

                        <!--Pagination -->
                        <nav class="my-4">
                            <ul class="pagination pagination-circle pg-blue mb-0">

                                <!--First-->
                                <li class="page-item disabled"><a class="page-link" mdbWavesEffect>First</a></li>

                                <!--Arrow left-->
                                <li class="page-item disabled">
                                    <a class="page-link" mdbWavesEffect aria-label="Previous">
                                        <span aria-hidden="true">«</span>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                </li>

                                <!--Numbers-->
                                <li class="page-item active"><a class="page-link" mdbWavesEffect>1</a></li>
                                <li class="page-item"><a class="page-link" mdbWavesEffect>2</a></li>
                                <li class="page-item"><a class="page-link" mdbWavesEffect>3</a></li>
                                <li class="page-item"><a class="page-link" mdbWavesEffect>4</a></li>
                                <li class="page-item"><a class="page-link" mdbWavesEffect>5</a></li>

                                <!--Arrow right-->
                                <li class="page-item">
                                    <a class="page-link" mdbWavesEffect aria-label="Next">
                                        <span aria-hidden="true">»</span>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </li>

                                <!--First-->
                                <li class="page-item"><a class="page-link">Last</a></li>

                            </ul>
                        </nav>
                        <!--/Pagination -->
                    </div>
                </div>
            </div>
            <!--Grid row-->

        </section>
        <!--/Projects section v.2-->
    </div>


</div>